export const ONE_SECOND_IN_MILLISECONDS = 1000 as const
export const ONE_MINUTE_IN_MILLISECONDS = ONE_SECOND_IN_MILLISECONDS * 60
